//import Service from "@/service/api"
import Service from "../../../service/api"
import store from "@/store/store";

const GetProfileModule = {
    namespaced: true,
    state: {
        userType: 0,
        profile: {},
        username: '',
        favouriteCourses: [],
        inProgressCourses: [],
        enRolledCourses: [],
        user_id: '',
        notice: []
    },
    mutations: {
        setUserType(state, res) {
            state.userType = res.data.userProfile.userType
        },
        setProfile(state, res) {
            state.profile = res.data.userProfile.userinfo
            state.username = res.data.userProfile.username
            state.user_id = res.data.userProfile._id
        },
        setUpdateUsername(state, data) {
            state.username = data
        },
        setCourses(state, data) { // v3 fixed
            // state.favouriteCourses = data.data.userCourse.favourite
            console.log('data.userCourse.enrolls', data)
            // state.enRolledCourses = data.data.userCourse.enrolls
            console.log('data.data.userCourse', data.data.userCourse)
            state.enRolledCourses = data.data.userCourse

        },
        setNotice(state, data) {
            state.notice = data.data
        },
        clearProfile(state) {
            state.profile = ''
        }
    },
    actions: {
        getUserNoticeData({ commit }) {

            Service.onGetNotice().then((res) => {
                commit('setNotice', res)
            }).catch(err => {
                if (err.response.status === 401) {
                    //store.dispatch("auth/logout")
                }
            })
        },
        getUserProfile({ commit }) {
            console.log('=========================')
            console.log('vuex ---> getUserProfile')
            if (store.getters["auth/userStatus"] === true) {
                Service.fetchUserDataAPI().then((res) => {
                    console.log('getUserProfile',res.data)
                    commit('setUserType', res.data)
                    commit('setCourses', res.data)
                    commit('setProfile', res.data)
                }).catch(err => {
                    if (err.response.status === 401) {
                        store.dispatch("auth/logout")
                    }
                })
            }
            console.log('=========================')
        },
    },
    getters: {
        getProfile(state) {
            return state.profile;
        },
        getUsername(state) {
            return state.username
        },
        getUserType(state) {
            return state.userType
        },
        getFavouriteCourses(state) {
            return state.favouriteCourses;
        },
        getInProgressCourses(state) {
            return state.inProgressCourses;
        },
        getEnRolledCourses(state) {
            return state.enRolledCourses;
        },
        getUserId(state) {
            return state.user_id
        },
        getUserNotice(state) {
            return state.notice
        }
    }
}

export default GetProfileModule;